export default __webpack_public_path__ + "static/media/home4.4c67337d.png";